<template>
  <section style="position:relative" id="section">
		

    <el-row class="statusRowWhite">
    		<div class="RowChild">
    			 &nbsp;公司名称：  &nbsp;
			<el-select v-model="pdata.cp_company_id" filterable  clearable    placeholder="请选择公司名称"  @change='getList'>
		    <el-option
		      v-for="item in companyList"
		      :key="item.id"
		      :label="item.name"
		      :value="item.id">
		    </el-option>
			</el-select>
			</div>
    	<div class="RowChild">
      &nbsp;结算期：  &nbsp;
	     <el-date-picker
      v-model="pdata.d_date"
      type="month"
      format="yyyyMM"
	    value-format="yyyyMM"
	    @change='getList'
      placeholder="选择月">
    </el-date-picker>
    </div>
    <div class="RowChild">
    	&nbsp;分成方式：  &nbsp;
		 <el-select class="xs24" v-model="pdata.bill_type" placeholder="请选择账单类型"   @change='getList'>
		    <el-option key="1" label="原生分成账单" value="1"></el-option>					  
		    <el-option key="2" label="利润分成账单" value="2"></el-option>
			</el-select>
		</div>
    <div class="RowChild">
			<el-button size="small" type="primary" @click="batchProduct">导入</el-button>
		</div>
    <div class="RowChild">
      <el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>
     </div>
    <div class="RowChild">
      <el-button size="medium" icon="el-icon-download" type="primary" @click="getBillList"  v-if="pdata.cp_company_id!=''&&plist.length>0">导出预览</el-button>
    </div>
    <div class="RowChild">
      <el-button size="medium" type="primary" @click="$router.push('/billCpData/summary')">分成汇总</el-button>
    </div>
  

     
		 
    </el-row>
    
    <el-row  style="padding:15px;background:#fff">

	    <!--列表-->
	    <el-table
	      :data="plist"
	      style="width: 100%;"
	      stripe
	      row-key="id"

	      class="demo-table"
	      show-summary
	      :summary-method="getSummaries" 
	    >

	    <!-- <el-table-column type="selection" min-width="30px"></el-table-column>-->
	     <el-table-column prop="bill_cp_data_id"  label="ID" min-width="50px" width="50" align="center"></el-table-column>
	     <el-table-column prop="date"  label="结算周期" min-width="140px" align="center" ></el-table-column>
	     
	     <el-table-column prop="company_name"  label="公司名称"  align="center"  min-width="100px"></el-table-column>
	     <el-table-column prop="name"  label="游戏名称"  align="center"  min-width="100px"></el-table-column>
	     <el-table-column prop="appid"  label="appid"  align="center" min-width="140px"></el-table-column>
	     
	     <el-table-column prop="other_cost"  label="其他费用"  align="center"  v-if="pdata.bill_type==1"></el-table-column>
	     <el-table-column prop="origin_income"  label="原生收入"  align="center" ></el-table-column>
	     
	     <el-table-column prop="sell_income"  label="分发收入"  align="center"  v-if="pdata.bill_type==2"></el-table-column>
	     <el-table-column prop="export_cost"  label="导量成本"  align="center"  v-if="pdata.bill_type==2"></el-table-column>
	     <el-table-column prop="profit"  label="利润"  align="center" v-if="pdata.bill_type==2"></el-table-column>
	     
	     
	     
	     
	     
	     
	     <el-table-column prop="divide_per"  label="结算比例"  align="center" ></el-table-column>
	     
	     <el-table-column prop="tax_point"  label="应扣税点"  align="center"  >
	     	 <template slot-scope="scope">{{scope.row.tax_point}}%</template>
	     </el-table-column>
	     
	     <el-table-column prop="total_cost"  label="结算金额"  align="center"></el-table-column>
	     
	     <el-table-column prop="status"  label="操作" min-width="50px" width="400"  align="center">
	     		 <template slot-scope="scope">
							<el-button size="medium" type="primary" icon="el-icon-edit" @click="updateCPBillData(scope.row)">更新账单</el-button>
							<el-button size="medium" >明细</el-button>
							<el-button size="medium" @click="editRemark(scope.row)" >备注</el-button>
							
							<!--<el-button size="medium"  @click="editRule(scope.row)">下载</el-button>-->
							<el-button size="medium"  @click="openDealy(scope.row.bill_cp_data_id)">操作日志</el-button>
	     		 </template>
	     </el-table-column>
	     
	    
	    </el-table>
    
    </el-row>
    <el-row  style="padding:15px;background:#fff">
    	<el-col :span="24" v-for="item in plist" v-if="item.remark!=''&&item.remark!=''">
    		{{item.remark}}
    		
    	</el-col>
    </el-row>
    
<!--  
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80,200]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
    -->

   
     <el-dialog
      :title="isAdd?'结算':'结算'"
      :visible.sync="billDialog"
      top="5vh"
      :width="pdata.bill_type==1?'950px':'1150px'"
      custom-class="dialog"
      :close-on-click-modal="false"
      center
    >
      <el-form  :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	
				    <div  class="el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%;">
							<div class="el-table__header-wrapper">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" :style="pdata.bill_type==1?'width: 900px;':'width:1100px'" id="ta"  >
									<colgroup v-if="pdata.bill_type==1">
										<col name="el-table_3_column_28_column_29" width="145">
										<col name="el-table_3_column_28_column_30" width="100"  >
										<col name="el-table_3_column_28_column_31" width="155" >
										<col name="el-table_3_column_28_column_32" width="70">
										
										<col name="el-table_3_column_28_column_33" width="110">
										<col name="el-table_3_column_28_column_34" width="110">
										<col name="el-table_3_column_28_column_35" width="105">
										<col name="el-table_3_column_28_column_36" width="105">
									</colgroup>
										<colgroup v-if="pdata.bill_type==2">
										<col name="el-table_3_column_28_column_29" width="145">
										<col name="el-table_3_column_28_column_30" width="155"  >
										<col name="el-table_3_column_28_column_31" width="160" >
										<col name="el-table_3_column_28_column_32" width="90">
										
										<col name="el-table_3_column_28_column_33" width="110">
										<col name="el-table_3_column_28_column_34" width="110">
										<col name="el-table_3_column_28_column_35" width="105">
										<col name="el-table_3_column_28_column_36" width="75">
										<col name="el-table_3_column_28_column_36" width="60" >
										<col name="el-table_3_column_28_column_36" width="90">
									</colgroup>
									
								
									<thead class="is-group has-gutter" v-if="pdata.bill_type==1">
										
										<tr class="">
											<td colspan="8" rowspan="1" class="el-table_3_column_28  is-center  ">
												<div class="cell">产品结算对账单</div>
											</td>
										</tr>
										<tr class="">
											<td colspan="8" rowspan="1" class="el-table_3_column_28  is-right  " style="text-align: right;">
												<div class="cell">结算单编号：{{bill_no}}</div>
											</td>
										</tr>
										<tr class="">
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_29  is-center   is-leaf">
												<div class="cell">结算周期</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_30  is-center   is-leaf">
												<div class="cell">游戏名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_31  is-center   is-leaf">
												<div class="cell">appid</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_32  is-center   is-leaf">
												<div class="cell">其他费用</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_33  is-center   is-leaf">
												<div class="cell">原生收入/利润</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_34  is-center   is-leaf">
												<div class="cell">结算比例</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_35  is-center   is-leaf">
												<div class="cell">应扣税点</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">结算金额</div>
											</th>
										</tr>
									</thead>
									       
									<thead class="is-group has-gutter" v-if="pdata.bill_type==2">
										<tr class="">
											<td colspan="10" rowspan="1" class="el-table_3_column_28  is-center  ">
												<div class="cell">产品结算对账单</div>
											</td>
										</tr>
										<tr class="">
											<td colspan="10" rowspan="1" class="el-table_3_column_28  is-right  "  style="text-align: right;">
												<div class="cell">结算单编号：{{bill_no}}</div>
											</td>
										</tr>
										<tr class="">
											<th colspan="10" rowspan="1" class="el-table_3_column_28  is-left  ">
												<div class="cell">结算单明细:</div>
											</th>
										</tr>
										<tr class="">
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_29  is-center   is-leaf">
												<div class="cell">结算周期</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_30  is-center   is-leaf">
												<div class="cell">游戏名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_31  is-center   is-leaf">
												<div class="cell">appid</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_32  is-center   is-leaf">
												<div class="cell">原生收入</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_33  is-center   is-leaf">
												<div class="cell">分发收入</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_34  is-center   is-leaf">
												<div class="cell">导量成本</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_35  is-center   is-leaf">
												<div class="cell">利润</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">结算比例</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">税点</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">结算金额</div>
											</th>
											
										</tr>
									</thead>
									
						
								

									<tbody class="el-table__body">
										
										
										<tr class="el-table__row" :class="index%2==1?'el-table__row--striped':''" v-for="item,index in billList" v-if="pdata.bill_type==1">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												<div class="cell"><span >{{item.date}}</span></div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												<div class="cell">{{item.name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												<div class="cell">{{item.appid}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
												<div class="cell">{{item.other_cost}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												<div class="cell" >{{item.origin_income}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												<div class="cell">{{item.divide_per}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												<div class="cell">{{item.tax_point}}%</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.total_cost}}</div>
											</td>
										</tr>

								   		
								   	<tr class="el-table__row" :class="index%2==1?'el-table__row--striped':''" v-for="item,index in billList"  v-if="pdata.bill_type==2">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												<div class="cell"><span >{{item.date}}</span></div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												<div class="cell">{{item.name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												<div class="cell">{{item.appid}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
												<div class="cell">{{item.origin_income}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												<div class="cell" >{{item.sell_income}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												<div class="cell">{{item.export_cost}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												<div class="cell">{{item.profit}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.divide_per}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.tax_point}}%</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.total_cost}}</div>
											</td>
										</tr>
										
										<tr>
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										
										<tr v-if="pdata.bill_type==1">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												总计
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
												￥{{total.other_cost.toFixed(2)}}
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												￥{{total.origin_income.toFixed(2)}}
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												-
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												-
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												￥{{total.total_cost.toFixed(2)}}
											</td>
										</tr>
										
										<tr  v-if="pdata.bill_type==2">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												总计
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												￥{{total.sell_income.toFixed(2)}}
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												￥{{total.profit.toFixed(2)}}
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												-
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												-
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												￥{{total.total_cost.toFixed(2)}}
											</td>
										</tr>
										
									
										
										<tr>
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">
												{{pdata.bill_type=='1'?'结算金额 =（原生收入 * 结算比例 + 其他费用（按月）*（1 - 应扣税点））':'结算金额=利润*结算比例*（1-税点）'}}
											</td>
										</tr>
										
										<tr v-for="item in plist" v-if="item.remark!=''&&item.remark!=null">
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">
												{{item.remark}}
											</td>
										</tr>
										
										<tr>
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-center " style="color: #f2f2f2;">
												┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄
											</td>
										</tr>
										
										<tr>
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-center ">
												以上金额确认无误，请盖章后寄回
											</td>
										</tr>

										<tr>
											<td rowspan="1" :colspan="pdata.bill_type==1?'8':'10'" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										
										<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">公司名称 ：{{company.name}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[0]}}</td>
							    	</tr>
							    	
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">收款银行：{{company.opening_bank}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[1]}}</td>
							    	</tr>
							    	<tr>
								    <td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">银行账号：{{company.receiving_account}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[2]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">联系人：{{company.contact}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[3]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">联系电话 ：{{company.phone}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[4]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">邮寄地址：{{company.email_addr}}</td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[5]}}</td>
							    	</tr>
							    	
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;"></td>
								    	<td rowspan="1" :colspan="pdata.bill_type==1?'4':'6'" class="el-table_3_column_28_column_36 is-left " style="text-align: left;padding-left: 10px;">{{wecompany[6]}}</td>
							    	</tr>
							    
										
										
										
										<!---->
									</tbody>
									
								</table>
							</div>

						</div>
				  
    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tableToExcel" >导出Excel</el-button>
        <el-button @click="handleDown" >导出pdf</el-button>
        <el-button @click="billDialog = false">取消</el-button>
      </div>
    </el-dialog>
    


    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
    
    <el-dialog title="备注" :visible.sync="remarkDialog">
     <el-form  :rules="remarkRules" ref="ruleForm" label-width="140px">
     	 <el-row :gutter="5" style="margin:0;">
		        	<el-col :span="24">
		        		<el-form-item label="请输入备注信息" prop="ramark">
				          <el-input placeholder="请输入" v-model="remarkForm.remark" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		    </el-row>    	
     </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </div>
    </el-dialog>
    
    
    <el-dialog title="导入" :visible.sync="batchDialog" width="650px" :close-on-click-modal="false">
      <el-form  :rules="rules" ref="ruleForm" label-width="140px">
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				:headers="headers"
				:on-success="batchSuccess"
				name="file"
				:show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips==0?'导入预览':'以下数据已存在，是否覆盖'}}</el-col>
       </el-row>
       <el-row :gutter="5" v-for="item,index in batchForm" :key="index" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="6" v-for="(citem,idx) in  item" :key="idx">
       				{{citem}}
       		</el-col>	
       		
       </el-row>
      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit">{{batchTips=='0'?'确认':'再次确认'}}</el-button>
      </div>
    </el-dialog>
    
     <el-dialog title="更新日志" :visible.sync="cpEditDialog" :close-on-click-modal="false">
      	<el-form :model="editForm" :rules="editFormRules" ref="ruleForm" label-width="220">
		        <el-row :gutter="5" style="margin:0;">
		        	<el-col :span="24">
		        		<el-form-item label="其它费用（原生分成）" prop="other_cost" v-if="pdata.bill_type==1">
				          <el-input placeholder="请输入" v-model="editForm.other_cost" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		        	<el-col :span="24">
		        		<el-form-item label="原生收入" prop="origin_income">
				          <el-input placeholder="请输入" v-model="editForm.origin_income" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		        	<el-col :span="24">
		        		<el-form-item label="结算比例" prop="divide_per">
				          <el-input placeholder="请输入" v-model="editForm.divide_per" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		        	<el-col :span="24">
		        		<el-form-item label="分发收入（利润分成）" prop="sell_income" v-if="pdata.bill_type==2">
				          <el-input placeholder="请输入" v-model="editForm.sell_income" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		        	<el-col :span="24">
		        		<el-form-item label="导量成本（利润分成）	" prop="export_cost" v-if="pdata.bill_type==2">
				          <el-input placeholder="请输入" v-model="editForm.export_cost" class="w220"></el-input>
				        </el-form-item>
		        	</el-col>
		        </el-row>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cpEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveCPBillData">确 定</el-button>
      </div>
    </el-dialog>
    
  </section>
</template>

<script>
import htmlToPdf from '../../vendor/htmlToPdf'
import $ from "jquery";
import { getCPBillDataList ,getCPCompanyList,sclog,baseUrl,batchCPAdd,CPEdit,CPRemark } from "../../api/api";
//import UploadImg from "./uploadImg.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank:[{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account:[{ required: true, message: "请输入收款账号", trigger: "blur" }]
      },
      editFormRules:{
      	other_cost: [{ required: true, message: "请输入其它费用（原生分成）", trigger: "blur" }],
      	origin_income: [{ required: true, message: "请输入原生收入", trigger: "blur" }],
      	divide_per: [{ required: true, message: "请输入结算比例", trigger: "blur" }],
      	sell_income: [{ required: true, message: "请输入分成收入（利润分成）", trigger: "blur" }],
      	export_cost: [{ required: true, message: "请输入导量成本（利润分成）", trigger: "blur" }]
      },
      remarkRules:{
      	remark:[{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        cp_company_id:"",
				bill_type:'1', 
				d_date:(new Date().getMonth()+1)<10?new Date().getFullYear().toString()+'0'+(new Date().getMonth()+1):new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
      },
      plist: [],
      company_a:'',
      company_b:'',
      bill_no:'',
      billList:[],
      company:'',
      wecompany:[],
      bill:'',
      companyList:[],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      prWidth: 0,
      editForm: {
			},
			billDialog:false,
			height:710,
			batchForm:[],
			url:baseUrl+"billCpData/preview",
      headers:{
          'token':this.$cookie.getCookie("login")
      },
      batchDialog:false,
      batchTips:0,
      batchPreDate:'',
      cpEditDialog:false,
      total:{
      	other_cost:0, //其他费用
      	origin_income:0,  //原生收入
      	total_cost:0,  //结算金额
      	profit:0, //利润
      	sell_income:0, //分发收入
      	
      },
      remarkDialog:false,
      remarkForm:{
      	bill_cp_data_id:'',
      	remark:''
      	
      },
    };
  },
  watch: {
  	"pdata.stype": {
      handler(n, o) {
      	this.getList();
      },
      deep: true
   },
    "pdata.status": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },
    "pdata.kw": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },
    "pdata.company_id": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },
    "pdata.date":{
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    }

  },
  methods: {
  	//导入
    batchProduct(){
    	this.batchDialog=true;
    	this.batchTips = 0;
    	this.batchPreDate='';
    },
    downloadTemp(){
  		window.location.href='/static/bill.csv';
  	},
  	batchSuccess(response, file, fileList){
  		if(response.code==200){
  			this.batchForm=response.data;
  			this.batchPreDate = this.batchForm[1][0].split('-')[0].substring(0,6)
  		}
  	},
  	batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips=0;
    },
    batchSubmit(){
	    var p =	{"confirm":this.batchTips,"import_data":this.batchForm};
	    batchCPAdd(p, this.$cookie.getCookie("login")).then(response => {
	        if (response.code == 200) {
	        	debugger
	         	 if(response.data.length>1){
	        			this.batchForm=response.data;
	        			this.batchTips="1";
	         	 }
	         	 else{
	         	 	 this.$message({ message: "导入成功", type: "success" });
	         	 	 this.batchDialog = false;
	         	 	 this.batchForm=[];
	         	 	 this.pdata.d_date = this.batchPreDate;
	         	 	 this.getList()
	         	 }
	        }
	        else{
	        	this.$message.error('导入失败');
	        }
	     });
    },
  	handleDown () {
        htmlToPdf.downloadPDF(document.querySelector('#ta'),  this.company.name+"结算对账单")
    },
  	getSummaries(param) {
		    const { columns, data } = param;
		    const sums = [];
		    columns.forEach((column, index) => {
		      if (index === 0) {
		        sums[index] = '合计';
		        return;
		      }
	      	if(index === 1||index===2||index===3||index===4){
	      	 		 sums[index] = '-';
	      	 			return;
	      	}
	      	if(this.pdata.bill_type==1){
	      			if(index===7||index===8){
	      	 		 sums[index] = '-';
	      	 			return;
	      		}
	      	}
	      	if(this.pdata.bill_type==2){
	      			if(index===9){
	      	 		 sums[index] = '-';
	      	 			return;
	      		}
	      		if(index===10){
	      	 		 sums[index] = '-';
	      	 			return;
	      		}
	      	}
		      const values = data.map(item => Number(item[column.property]));
		      if (!values.every(value => isNaN(value))) {
		        sums[index] = values.reduce((prev, curr) => {
		          const value = Number(curr);
		          if (!isNaN(value)) {
		            return prev + curr;
		          } else {
		            return prev;
		          }
		        }, 0);
		        sums[index] ='￥'+ sums[index].toFixed(2)  ;
		      } else {
		        sums[index] = '-';
		      }
		    });
		
		    return sums;
		},
  	//数据导出
    handleDownload() {
      var that = this;
      var arr = [];
      var arrHd = ["开始日期","结束日期", "游戏名称", "渠道名称", "平台","合作方式","新增人数","单价(元/个)","应收金额"];
      var arrFval = ["bill_sdate","bill_edate","product_name","channel_name", "platform","type","num","unit","bill_amount" ];
//    if (that.tablelistAll.length > 0) {
//      that.exclelist = arr.concat(that.tablelistAll);
//    } else {
//      that.exclelist = arr.concat(that.tablelist);
//      arrHd = arrHd.splice(1);
//      arrFval = arrFval.splice(1);
//    }
      that.billList.forEach((v,i)=> {
        v.bill_amount = v.num*v.unit
      });
      console.log(that.billList);
      if (that.billList == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      require.ensure([], () => {
        const {
          export_json_to_excel,
          export_table_to_excel
        } = require("../../vendor/Export2Excel.js");
        const tHeader = arrHd;
        const filterVal = arrFval;
        const list = this.billList;

        const data = this.formatJson(filterVal, list);
				data.push([""])
				data.push([""])
        data.push(["结算类型",this.company.type==1?"企业":"个人"])
        data.push(["发票类型",this.bill.invoice_type==1?'普通发票':'增值发票'])
        data.push(["新增用户",this.bill.num])
        data.push(["税点",this.bill.tax_point+'%'])
        data.push([this.company.type==1?"结算金额":"结算金额(扣去税点后金额)",this.bill.bill_amount])
        data.push(["结算金额（人民币大写）",this.bill.big_bill_amount])
        data.push([""])
        data.push([""])
        data.push(["甲方公司:"+this.company.name,null,null,null,this.wecompany[0]])
        data.push(["税号:"+this.company.social_credit_code,null,null,null,this.wecompany[3]])
        data.push(["注册地址:"+this.company.company_addr,null,null,null,this.wecompany[4]])
        data.push(["注册电话:"+this.company.company_phone,null,null,null,this.wecompany[8]])
        data.push(["开户银行:"+this.company.opening_bank,null,null,null,this.wecompany[1]])
        data.push(["银行账号:"+this.company.receiving_account,null,null,null,this.wecompany[2]])
        data.push(["联系人:"+this.company.contact,null,null,null,this.wecompany[6]])
        data.push(["联系电话:"+this.company.phone,null,null,null,this.wecompany[7]])
        data.push(["邮寄地址:"+this.company.email_addr,null,null,null,this.wecompany[5]])


				   	
				   	
       
        
      
        export_json_to_excel(
          tHeader,
          data,
          this.company.name+"结算对账单"
        );
//      export_table_to_excel("ta");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  	search() {
      this.getList();
    },



  	createBillData(){
  		 this.editDialog = true;
  	},
  	
  	
  	updateCPBillData(s,index){
  		this.cpEditDialog = true;
  		this.editForm = {
  			bill_cp_data_id:s.bill_cp_data_id,
				other_cost:s.other_cost,
				origin_income:s.origin_income,
				divide_per:s.divide_per,
				sell_income:s.sell_income,
				export_cost:s.export_cost
  		}
			
  	},
  	saveCPBillData(){
  		
  		CPEdit(this.editForm, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	        	 this.cpEditDialog = false;
	        	 this.$notify({
		          title: '通知',
		          message: "编辑成功",
		          type: 'success'
		        });
	        	this.getList()
	        }
	        else{
			        	this.$message.error(res.msg);
			    }
	     });
	     
  	},
  	editRemark (s){
  		this.remarkDialog = true;
  		this.remarkForm.remark = s.remark;
  		this.remarkForm.bill_cp_data_id = s.bill_cp_data_id;
  	},
  	saveRemark () {
  		CPRemark(this.remarkForm,this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	        	 this.remarkDialog = false;
	        	 this.$notify({
		          title: '通知',
		          message: "备注成功",
		          type: 'success'
		        });
	        	this.getList()
	        }
	        else{
			        	this.$message.error(res.msg);
			    }
	     });
  	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getCPBillDataList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
            this.maxPage = res.data.max_page;
            if(this.pdata.cp_company_id!=''){
            	this.company_a = res.data.company_a;
            	this.company_b = res.data.company_b
            	this.bill_no = res.data.bill_no;
            	this.total={
					      	other_cost:0,
					      	origin_income:0,
					      	total_cost:0,
					      	profit:0,
					      	sell_income:0,
					    }
            	this.plist.forEach((v,i) => {
            		 this.total.origin_income += parseFloat(v.origin_income);
            		 this.total.total_cost +=  parseFloat(v.total_cost);
            		 if(this.pdata.bill_type==1){
            		 	 this.total.other_cost +=  parseFloat(v.other_cost)
            		 	 
            		 }
            		 if(this.pdata.bill_type==2){
            	
            		 	this.total.sell_income += parseFloat(v.sell_income)
            		 	console.log(v.sell_income);
            		 	console.log(this.total.sell_income)
            		 	this.total.profit +=  parseFloat(v.profit)
            		 }
            	})
            }
        	}
        	else{
        		this.plist = [];
            this.maxPage =1;
        	}
          
        }
      });

    },
    getBillList(status,company_id,id) {
    	this.billDialog=true;
    	this.company=this.company_a;
    	this.wecompany=this.company_b;
    	this.billList =this.plist;
    },
    openDealy(id) {
  	 	var p = 'type=bill_cp_data&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    
    base64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    },
    //替换table数据和worksheet名字
    format (s, c) {
        return s.replace(/{(\w+)}/g,
            function (m, p) {
                return c[p];
            });
    },
    tableToExcel() {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' +
            'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
            + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>'
            + '</x:ExcelWorkbook></xml><![endif]-->' +
            ' <style type="text/css">' +
            'table td {' +
   
            'width: auto;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            'table th {' +
    
            'width: auto;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            '</style>' +
            '</head><body ><table class="excelTable" border="1" cellspacing="1" cellpadding="1">{table}</table></body></html>';
            var tableid = document.getElementById('ta');
           
            var ctx = {worksheet: this.company.name+"结算对账单" || 'Worksheet', table: tableid.innerHTML};
        		console.log(uri + this.base64(this.format(template, ctx)));
        	//	location.href = uri + this.base64(this.format(template, ctx));
        	this.base64ToFile(uri + this.base64(this.format(template, ctx)))
    },
    base64ToFile(base) {
      const arr = base.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      if (window.navigator.msSaveBlob) {
        // for ie 10 and later
        try {
          const blobObject = new Blob([u8arr], { type: mime });
          window.navigator.msSaveBlob(blobObject,  this.company.name+'.xls');
        } catch (e) {
          console.log(e);
        }
      } else {
        const url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.company.name+'.xls');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      }
    },
    getCPCompany(){
    	getCPCompanyList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
    }
    
        
  },
  computed: {
	    ...mapGetters([
	    	'groupid'
	    ])
  },
  created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height()-400
  },
  mounted() {
  	this.pdata.cp_company_id = this.$route.query.cp_company_id;
  	this.pdata.bill_type =  this.$route.query.bill_type;
  	this.pdata.d_date = this.$route.query.d_date;
    this.getList();
    this.getCPCompany();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
.bill{

	line-height: 48px;
	text-align: center;
	margin: 20px 0;
	overflow: hidden;
	border-top:1px solid #F2F6FC;
}
.bill .el-row{
	border-bottom:1px solid #F2F6FC;
	border-right:1px solid #F2F6FC;

	
}
.bill .el-row .el-col:first-child{
	
	border-right:1px solid #F2F6FC;
}
</style>

<style >

#ta,#ta .el-table__header-wrapper tbody td , #ta.el-table thead {
	color: #000000 ;
}
.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}

.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// dataList.vue?7725290e